module.exports = __webpack_public_path__ + "static/media/uk_flag.6f382b2d.png";